export const IDIOMAS = {
    CATALAN: 'ca',
    SPANISH: 'es'
};

export const USER_ROLES = {
    admin: 'admin',
    usuario: 'usuario,'
};

export const ALERTA_TIPO = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
};

export const LOCAL_STORAGE_IDIOMA = "idioma";

export const COLORES_APP = {
    AZUL: '#427698',        // Pantone 7468
    AMARILLO: '#C4A84F',    // Pantone 457
    MARRON: '#53534C',      // Pantone Black 7
};

export const CONEXIONES_VER = {
  	DIA: 1,
  	SEMANA: 2,
  	MES: 3,
};